import React from "react"
import PropTypes from "prop-types"
import moment from "moment"
import ActivityTimeline from "../ActivityTimeline"
import UsersGroupedByRole from "../UsersGroupedByRole"
import Event from "../ActivityTimeline/Event"
import "./VisitTimeline.scss"
import "./HourlyRoundsTimeline.scss"

export default class HourlyRoundsTimeline extends React.PureComponent {
  hourlyEvents = (hourlySummary, roundingPeriodMinutes) => {
    return hourlySummary.map(hour => {
      const startsAt = moment.parseZone(hour.startsAt)
      const endsAt = moment.parseZone(hour.endsAt)
      let filteredPrimaryProvider = []
      let filteredSecondaryProvider = []
      let subclass = ""

      if (hour.compliant === undefined || hour.compliant === null)
        subclass = "empty"
      else if (hour.compliant) {
        subclass = "good"

        // sort visits by longest vist duration
        const sortedUserVisits = hour.userVisits.sort(
          (a, b) => b.visitDuration - a.visitDuration
        )

        filteredPrimaryProvider = sortedUserVisits.filter(
          nurse => nurse.userHealthcareRoleType === "primary"
        )

        // if we don't have a primary, the round was completed by a secondary provider
        if (filteredPrimaryProvider.length === 0) {
          filteredSecondaryProvider = sortedUserVisits.filter(
            nurse => nurse.userHealthcareRoleType === "secondary"
          )
        }
      } else subclass = "bad"

      return (
        <React.Fragment key={startsAt.toISOString()}>
          <Event
            className={`hourlySummary ${subclass}`}
            tooltipContent={
              <div className="tooltip-content">
                <div className="time-range">
                  {startsAt.format("h:00a").slice(0, -1)}
                  <div className="dash">-</div>
                  {endsAt.format("h:00a").slice(0, -1)}
                </div>
                {subclass.includes("good") && (
                  <UsersGroupedByRole users={hour.userVisits} />
                )}
                {subclass.includes("empty") && <p>room not occupied</p>}
                {subclass.includes("bad") && <p>no visits detected</p>}
              </div>
            }
            tooltipOptions={{
              className: `Visit`,
            }}
            startAt={startsAt.add(roundingPeriodMinutes / 2, "minutes")}
            endAt={endsAt.add(roundingPeriodMinutes / 2, "minutes")}
            nurseInfo={
              filteredPrimaryProvider[0] || filteredSecondaryProvider[0]
            }
          />
        </React.Fragment>
      )
    })
  }

  addEmptyRounds = ({ startsAt, endsAt, roundingPeriodMinutes, rounds }) => {
    const shiftLength = moment
      .duration(moment(endsAt).diff(moment(startsAt)))
      .asMinutes()
    const numRoundsExpected = shiftLength / roundingPeriodMinutes
    const roundStartCursor = moment(startsAt).clone()

    for (let i = 0; i < numRoundsExpected; i++) {
      if (
        !rounds[i] ||
        !rounds[i].startsAt ||
        !roundStartCursor.isSame(rounds[i].startsAt)
      ) {
        //push an "empty" round
        rounds.splice(i, 0, {
          startsAt: roundStartCursor.toISOString(true),
          endsAt: roundStartCursor
            .clone()
            .add(roundingPeriodMinutes, "minutes")
            .toISOString(true),
          compliance: null,
        })
      }
      roundStartCursor.add(roundingPeriodMinutes, "minutes")
    }
    return rounds
  }

  render() {
    return (
      <div className="HourlyRoundsTimeline VisitTimeline">
        <div className="title">Hourly Rounds Activity</div>
        <ActivityTimeline
          startAt={moment.parseZone(this.props.startsAt)}
          endAt={moment.parseZone(this.props.endsAt)}
          markerInterval={moment.duration(
            this.props.roundingPeriodMinutes,
            "minutes"
          )}
          markerRenderer={() => <div className="large" />}
          markerLabelRenderer={time => (
            <div className="primary">{time.format("ha").slice(0, -1)}</div>
          )}
        >
          {this.hourlyEvents(
            this.addEmptyRounds(this.props),
            this.props.roundingPeriodMinutes
          )}
        </ActivityTimeline>
      </div>
    )
  }
}

HourlyRoundsTimeline.defaultProps = {
  rounds: [],
}

HourlyRoundsTimeline.propTypes = {
  // An array of visits to display on the timeline.
  rounds: PropTypes.array.isRequired,
  roundingPeriodMinutes: PropTypes.number.isRequired,
  startsAt: PropTypes.string.isRequired,
  endsAt: PropTypes.string.isRequired,
}
